import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { MeActionTypes } from '../../actions/types';

const loginUser = makeAsyncReducerHandlers(
  MeActionTypes.loginUser,
  (state, action) => ({
    item: state.item,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    item: action.payload.me,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    item: state.item,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const getMe = makeAsyncReducerHandlers(
  MeActionTypes.getMe,
  (state, action) => ({
    item: state.item,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    item: action.payload.me,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    item: state.item,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const logoutUser = makeAsyncReducerHandlers(
  MeActionTypes.logoutUser,
  (state, action) => ({
    item: state.item,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    item: {},
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    item: state.item,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const updateUserInteractions = makeAsyncReducerHandlers(
  MeActionTypes.updateUserInteractions,
  (state, action) => ({
    item: state.item,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    item: state.item._id === action.payload.me._id
      ? { ...state.item, interactions: action.payload.me.interactions }
      : state.item,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    item: state.item,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  loginUser,
  getMe,
  logoutUser,
  updateUserInteractions,
};
